<template>
  <div class="pos-ticket">
    <div style="margin-top: 1rem;">
      <div>
        <div class="header">
          <div>
            <span style="font-size: 8px; line-height: 15px; display: block; text-align: center">
              FECHA DE EMISIÓN: {{ new Date().toLocaleString() }}
            </span>
          </div>
          <div style="font-size: 11px; text-align: center">{{ qr.serialNumber }}</div>
          <div class="type-ticket" style="padding-top: 10px">
            <span>Tipo de entrada </span><br>
            <span style="font-size: 14px font-weight: bold; padding-top: 10px"  >{{ qr.tribuna }}</span>
          </div>
        </div>
        <div class="container">
          <h4 style="text-align:center; font-size: 10px; font-weight: bold; margin-top: .4rem;">
            ORGANIZADO POR:
            <br>
            <span> {{ ticketInfo ? ticketInfo.OrgFirstName : '-' }} {{ ticketInfo ? ticketInfo.OrgLastName : '-' }}</span>
            <span v-if="ticketInfo && ticketInfo.OrgDniUser"> - {{ ticketInfo.OrgDniUser }}</span>
          </h4>
          <div class="date">
          <smal style="font-size: 14px; font-weight: bold; ">{{ qr.activityTitle }}</smal>
          <br>
          <small style="font-weight: bold;">{{qrDate}}</small>
          <br>
          <p class="m-0">
            Hora: {{ new Date(qr.dateStart).toLocaleTimeString() }} <br>
            {{ qr.name }} <br>
            {{ qr.type_document }} {{ qr.num_document }}
          </p>
          <br>
          </div>
          <div class="qrr" style="display: flex; justify-content: center;">
          <img style="width: 120px;" :src="`https://qr.joinnus.com/qr.png?size=110&amp;body=${qr.code}`">
          </div>
          <div class="content-date-price" style="display: block; text-align: center; margin-top: .3rem;">
            <div class="price">{{ qr.paymentCurrency === 'PEN' ? 'S/' : qr.paymentCurrency }} {{ qr.precio }}</div>
          </div>
        </div>
        <div style="display: flex; justify-content: center;">
          <img style="width: 100px;" src="https://s3-us-west-2.amazonaws.com/joinnus.com/content/whitebrand/logo-joinnus-k.jpg" width="70%">
        </div>
      </div>
      <br>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    qr: {
      type: Object,
      required: true,
    },
    ticketInfo: {
      type: Object,
      required: false,
    },
  },
  computed: {
    qrDate() {
      const qr = this.qr;
      return `${qr.day < 10 ? (`0${qr.day}`) : qr.day} DE ${this.getFormatMonth(qr.dateStart)} DEL ${qr.year}`;
    },
  }
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Open+Sans:300,400,700,800");
* {
    font-family: "Open Sans", sans-serif;
    box-sizing: border-box;
}
.header img {
    width: 100px;
    margin-left: 25%;
}

.type-ticket {
    display: block;
    text-align: center;
    font-size: 10px;
    line-height: 12px;
}
.type-ticket h4 {
    font-weight: bold;
    line-height: 8px !important;
    font-size: 13px;
}
.container {
    font-size: 13px;
}

.container h2 {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
}

.date {
    text-align: center;
    font-weight: bold;
    padding: 0px;
    margin: 0px;
}

.qr {
  padding: 10px;
  margin-left: 15%;
}

.price {
  font-size: 16px;
  font-weight: bold;
}


.pos-ticket {
  margin-top: 4rem;
  font-weight: bold;
  width: 250px;
  display: flex;
  justify-content: center;
  /* height: 400px; */

  font-family: sans-serif;
  background: #fff;
  border-radius: 10px;
  display: flex;
  position: relative;
  box-shadow: 0 1px 5px rgba(0,0,0, 0.2);
  transform: scale(1.2);
}
</style>